import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Breadcrumbs from '../../based/Breadcrumbs';
import CommonTable from '../../based/CommonTable';
import { CONSTANTS, INITPAGING, NOTIFY } from '../../based/Constants';
import { ConfirmDialog } from '../../based/Dialog';
import Loading from '../../based/Loading';
import { Notify } from '../../based/Notify';
import BaseServices from '../../based/services/BaseServices';
import AddOrEditGroup from './components/AddOrEditGroup';
const INIT_GROUP = {
    id: 0,
    name: '',
    users: []
}
const GroupAffiliator = () => {
    const [busy, setBusy] = useState(false);
    const [busyMsg, setBusyMsg] = useState('');
    const [groups, setGroups] = useState([]);
    const [paging, setPaging] = useState(INITPAGING);
    const [editingGroup, setEditingGroup] = useState(INIT_GROUP);
    const [showModalEditing, setShowModalEditing] = useState(false);
    useEffect(() => {
        _fetchData();
    }, [])
    const _fetchData = async () => {
        setBusy(true);
        setBusyMsg("Loading...")
        const [err, data] = await BaseServices.Post('/api/affiliate/get-group-affiliate', paging);
        if (!err) {
            setGroups(data.listObjects);
            setPaging(data.paging);
        }
        setBusy(false);
        setBusyMsg('')
    }
    const _handleAddGroup = async () => {
        setShowModalEditing(true);
        setEditingGroup(INIT_GROUP)
    }
    const _handleEdit = (gr) => {
        setShowModalEditing(true);
        setEditingGroup({ ...gr });
    }
    const _handleDelete = async (id) => {
        ConfirmDialog('Xác nhận xóa?', 'Bạn chắc chắn muốn xóa dữ liệu đã chọn?', () => {
            return new Promise(async (resolve, reject) => {
                setBusy(true)
                setBusyMsg('Đang xóa dữ liệu...')
                const [err, data] = await BaseServices.Post('/api/affiliate/delete-group-affiliate/' + id);
                if (err) {
                    setBusy(false)
                    setBusyMsg(null)
                    Notify(NOTIFY.WARNING, 'Có lỗi', CONSTANTS.MSG_ERROR);
                }
                else {
                    resolve({ title: 'Thành công', msg: 'Xóa thành công.' })
                    setBusy(false)
                    setBusyMsg(null)
                    _fetchData();
                }
            })
        });
    }
    const _handleCloseModal = () => {
        setEditingGroup(INIT_GROUP);
        setShowModalEditing(false);
    }
    const _handleSave = (success) => {
        if (success) {
            setShowModalEditing(false);
            setEditingGroup(INIT_GROUP);
            _fetchData();
        }
    }
    const _renderAction = () => {
        return <div className='flex-row m-b-10'>
            <button className='btn btn-custom btn-sm' onClick={_handleAddGroup}>
                Thêm mới
            </button>
        </div>
    }
    const _renderHeader = () => {
        return <thead>
            <tr>
                <th>Id</th>
                <th>Tên nhóm</th>
                <th>Affiliator</th>
                <th></th>
            </tr>
        </thead>
    }
    const _renderBody = () => {
        return <tbody>
            {

                groups.map((g, i) => {
                    return <tr key={i}>
                        <td width={50}>{g.id}</td>
                        <td>{g.name}</td>
                        <td>
                            <ul>
                                {
                                    g.thirdParties && g.thirdParties.map((t, ii) => {
                                        return <li key={ii}>{t.thirdPartyName} ({t.thirdPartyEmail})</li>
                                    })
                                }
                            </ul>
                        </td>
                        <td width={130}>
                            <button className='btn btn-sm btn-custom m-r-10' onClick={() => _handleEdit(g)}>Sửa</button>
                            <button className='btn btn-sm btn-danger' onClick={() => _handleDelete(g.id)}>Xóa</button>
                        </td>
                    </tr>
                })
            }
        </tbody>
    }
    return (
        <React.Fragment>
            <Breadcrumbs currentPage='Quản lý nhóm Affiliator' parentPage='Ranus' hrefParent='/' />
            <Loading show={busy} msg={busyMsg} />
            {
                groups && <CommonTable
                    data={groups}
                    paging={paging}
                    renderHeader={_renderHeader}
                    renderBody={_renderBody}
                    renderAction={_renderAction}
                    searchBasic
                    onFilter={(paging) => _fetchData(paging)}
                />
            }
            {
                showModalEditing && <AddOrEditGroup
                    group={editingGroup}
                    onClose={_handleCloseModal}
                    onSave={_handleSave}
                    show={showModalEditing}
                />
            }
        </React.Fragment>
    );
};

export default GroupAffiliator;